import { combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import { epic } from '@legacyApp/client/modules/app/epicService';
import { SPORTS_EVENTS_DATA_ELEMENT_REMOVED } from './sportsEventsData.constants';
import {
	sportsEventsDataRemoveData,
	sportsEventsDataRemoveId,
} from './sportsEventsData.actions';

const removeDataEpic = epic('removeDataEpic', {
	actions: (ofType) => ofType(SPORTS_EVENTS_DATA_ELEMENT_REMOVED),
	callback: ({ store$, action }) => {
		if (!store$.value.sportsEventsData) {
			return of();
		}
		const { dataType, eventId, elementId } = action;
		const actions = [
			sportsEventsDataRemoveId({ dataType, eventId, elementId }),
		];
		const elementsList =
			store$.value.sportsEventsData?.ids?.[dataType]?.[eventId];
		if (!elementsList?.length || elementsList.length <= 1) {
			actions.push(sportsEventsDataRemoveData({ dataType, eventId }));
		}
		return of(actions);
	},
});

const sportsEventsDataEpic = combineEpics(removeDataEpic);

export default sportsEventsDataEpic;
